var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yd-dialog",
    {
      attrs: { title: "", visible: _vm.visible, width: "400px", center: "" },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function () {
            return [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v("关 闭"),
              ]),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "div",
        { staticClass: "flex flex-justify-center", attrs: { id: "qrcodeBox" } },
        [_c("VueQr", { attrs: { text: _vm.codeUrl, size: 340 } })],
        1
      ),
      _vm._t("content", function () {
        return [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { align: "center" } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { width: "300px" },
                      attrs: { type: "primary", loading: _vm.loading },
                      on: { click: _vm.handleDownload },
                    },
                    [_vm._v("\n          下载二维码\n        ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }